import {FormGroup, ValidationErrors, Validator} from '@angular/forms';

/**
 * Only one field should have value (e.g. radio group)
 */
export class OnlyOneFieldValidator implements Validator {

    public static validator() {
        const validator = new OnlyOneFieldValidator();
        return (group: FormGroup): ValidationErrors | null => validator.validate(group);
    }


    validate(group: FormGroup): ValidationErrors | null {

        const values = group.value;
        let foundNum = 0;
        Object.keys(values).forEach(value => values[value] ? foundNum++ : 0);
        return foundNum > 1 ? {'onlyOneField': {foundNum: foundNum}} : null;

    }
}
